// extracted by mini-css-extract-plugin
export default {"bd":"index_bd_6sYIy","space40":"index_space40_y6aQK","space10":"index_space10_yti08"};